module.exports = __webpack_public_path__ + "img/tel_5.72a70556.png";